import { useDispatch, useSelector } from 'react-redux';
import api from './axiosInstance.js';
import {
  setImageLoading,
  setGeneratedImages,
  setImageError,
  setLastPayload
} from '../redux/createImageSlice.js';
import { hideToast, showToast } from '../redux/toasterSlice.js';
import { updatePastCreationData } from '../redux/pastCreateionsSlice.js';

export const useGenerateImages = () => {
  const dispatch = useDispatch();
  const { name, email } = useSelector((state) => state.auth);
  const {  generatedImages } = useSelector((state) => state.createImage);

  const generateImages = async (
    promptId,
    prompt,
    font,
    magic_prompt,
    uploaded_image_link,
    retryCount = 0
  ) => {
    if (retryCount >= 2) {
      return;
    }

    const payload = {
      api_name: 'gen_first_image_1',
      user_prompt: prompt,
      magic_prompt,
      uploaded_image_link,
      type: prompt,
      font_id: font?.md5,
      fontName: font?.font_name,
      fontFamilyUrl: font?.family_url,
      foundryName: font?.foundry_name,
      page_number: 1,
      modelName: 'TypeInContext Version 0.3.0',
      username: name?.trim(),
      email,
      prompt_id: promptId
    };

    // const url = `/fetch-image?api_name=gen_first_image_1&user_prompt=${encodeURIComponent(prompt)}&type=${encodeURIComponent(prompt)}&font_id=${font?.md5}&fontName=${font?.font_name}&fontFamilyUrl=${font?.family_url}&foundryName=${font?.foundry_name}&page_number=${1}&modelName=TypeInContext Version 0.3.0&username=${name?.trim()}&email=${email}&prompt_id=${promptId}`;

    const url = `/fetch-image?${new URLSearchParams(payload).toString()}`;

    try {
      dispatch(setImageLoading(true));
      dispatch(setLastPayload(payload));
      dispatch(
        showToast({
          message:
           `Generating new visuals using ${font?.font_name} font`,
          type: 'info',
        }),
      );

      const response = await api.get(url);

      dispatch(setGeneratedImages(response?.data?.data?.image));
      dispatch(updatePastCreationData(response?.data?.data?.image));
      dispatch(showToast({ message: 'Visuals generated successfully', type: 'success' }));
      return response;
    } catch (error) {
      const errorMessage = error?.response?.data?.message || 'Something went wrong';

      if (errorMessage.includes('no control image')) {
        await generateImages(
          promptId,
          prompt,
          font,
          magic_prompt,
          uploaded_image_link,
          retryCount + 1
        );
        return;
      }

      dispatch(hideToast());
      dispatch(showToast({ message: 'Failed to generate images', type: 'error' }));
      dispatch(setImageError(error?.response?.data?.message || 'Something went wrong'));
    }
  };

  return generateImages;
};